<template>
  <div class="container">
    <!-- 轮播 -->
    <van-swipe :height="600" :autoplay="3000" indicator-color="var(--text_color)">
      <van-swipe-item>
        <div class="info">
          <img class="img" src="@/assets/img/welcome_1.png" />
          <div class="title">{{ $t('welcome').title1 }}</div>
          <div class="txt">{{ $t('welcome').tips1 }}</div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="info">
          <img class="img" src="@/assets/img/welcome_2.png" />
          <div class="title">{{ $t('welcome').title2 }}</div>
          <div class="txt">{{ $t('welcome').tips2 }}</div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="info">
          <img class="img" src="@/assets/img/welcome_3.png" />
          <div class="title">{{ $t('welcome').title3 }}</div>
          <div class="txt">{{ $t('welcome').tips3 }}</div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="info">
          <img class="img" src="@/assets/img/welcome_4.png" />
          <div class="title">{{ $t('welcome').title4 }}</div>
          <div class="txt">{{ $t('welcome').tips4 }}</div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <!-- 按钮 -->
    <div class="btns">
      <van-button block @click="$router.push({ name: 'Register' })">{{ $t('welcome').bnt1 }}</van-button>
      <div class="logBtn" @click="$router.push({ name: 'Login' })">{{ $t('welcome').bnt2 }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .info {
    width: 100%;
    height: 100%;
    text-align: center;

    .img {
      margin-top: 30px;
      width: 300px;
      height: 300px;
    }

    .title {
      margin-top: 70px;
      font-size: 20px;
      font-weight: bold;
      color: var(--text_color);
    }

    .txt {
      margin-top: 15px;
      font-size: 14px;
      color: var(--ntext_color);
    }
  }

  .btns {
    margin: 20px 15px 20px 15px;
    text-align: center;

    .van-button {
      background: var(--text_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: var(--info_color);
    }

    .logBtn {
      margin-top: 20px;
      font-weight: bold;
      font-size: 15px;
      color: var(--text_color);
    }
  }
}

::v-deep .van-swipe__indicator {
  background-color: var(--ntext_color);
}
</style>
